import { PlanTypes } from 'mbs-ui-shared@models/PlanTypes.enum';

export const RestoreTypes: PlanTypes[] = [
  PlanTypes.RestoreDiskImagePlan,
  PlanTypes.RestorePlan,
  PlanTypes.RestoreVMware,
  PlanTypes.RestoreVMwareToCustom,
  PlanTypes.RestoreHyperV,
  PlanTypes.RestoreHyperVToCustom,
  PlanTypes.RestoreDataBasePlan,
  PlanTypes.RestoreDatabaseFilesPlan
];
